<template>
  <el-main>
    <el-row type="flex">
      <el-button style="margin-right: 10px;" width="100px;" type="primary" @click="getList">刷新<i class="el-icon-refresh-right el-icon--right"></i></el-button>
      <el-button style="margin-right: 10px;" width="100px;" type="primary" @click="dialogFormVisible = true">添加激活码</el-button>
    </el-row>
    <el-table style="margin-top: 10px" border v-loading="loading" :data="keys">
      <el-table-column prop="machineId" label="机器码">
      </el-table-column>
      <el-table-column prop="activationKey" label="激活码">
      </el-table-column>
      <el-table-column prop="machineRemark" label="机器备注">
      </el-table-column>
      <el-table-column prop="createdAt" label="创建日期">
        <template slot-scope="scope">
          {{getDate(scope.row.createdAt)}}
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="100">
        <template slot-scope="scope">
          <el-button @click="edit(scope.row)" type="text" size="small">添加备注</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="pageSize"
      layout="prev, pager, next, total"
      :total="total">
    </el-pagination>
    <KeyDialog ref="key_dialog" :keyValue="editKey" :dialogFormVisible.sync="dialogFormVisible" @refresh="getList"/>
  </el-main>
</template>

<style>
  .el-header {
    background-color: #B3C0D1;
    color: #333;
    line-height: 60px;
  }
  .el-aside {
    color: #333;
  }
</style>

<script>
// import oss from '../utils/oss'
import KeyDialog from '../components/KeyDialog'
import moment from 'moment'
export default {
  components: { KeyDialog },
  data () {
    return {
      loading: false,
      dialogFormVisible: false,
      mode: 'ai',
      list: [],
      keys: [],
      pageSize: 10,
      total: 0,
      currentPage: 1,
      editKey: {}
    }
  },
  mounted: async function () {
    this.getList()
    console.log(this.$route)
  },
  methods: {
    getDate (createdAt) {
      return moment(createdAt).format('YYYY-MM-DD HH:mm')
    },
    edit (row) {
      this.$refs.key_dialog.edit(row)
      this.dialogFormVisible = true
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    },
    async getList () {
      this.loading = true
      let result = {}
      try {
        result = await this.$store.dispatch('getKeys', {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      } catch (err) {
        console.log(err)
        this.$notify({
          title: '请求失败',
          type: 'error'
        })
        this.loading = false
        return false
      }
      const { code, data } = result.data
      if (code === 0) {
        this.keys = data.keys
        this.total = data.total
      }
      this.loading = false
    }
  }
}
</script>
